import lax from "lax.js";

lax.addPreset("parallax", () => {
  //translate-x : start poistion end position, speed offset "data-lax-translate-x": "0 500, 900 0",
  return {
    "data-lax-translate-y": "0 0 ,400 -300",
  };
});

lax.addPreset("fadeinOpacity", () => {
  return {
    "data-lax-opacity_desktop": "0 0.7, 800 -0.5",
  };
});

lax.addPreset("fadeinOpacityQuick", () => {
  return {
    "data-lax-opacity_desktop": "300 1, 800 1",
  };
});

lax.addPreset("fadeinOpacityText", () => {
  return {
    "data-lax-opacity_desktop": "300 1, 800 -1.5",
  };
});

lax.addPreset("parallaxBasic", () => {
  return {
    "data-lax-translate-y_desktop": "500 300 ,0 0",
  };
});

lax.addPreset("parallaxSlow1", () => {
  return {
    "data-lax-translate-y_desktop": "500 250 ,300 0",
  };
});

lax.addPreset("parallaxSlow2", () => {
  return {
    "data-lax-translate-y_desktop": "700 100 ,400 0",
  };
});

lax.addPreset("parallaxSlow3", () => {
  return {
    "data-lax-translate-y_desktop": "500 500 ,250 0",
  };
});

lax.addPreset("parallaxSlow4", () => {
  return {
    "data-lax-translate-y_desktop": "600 100 ,500 0",
  };
});

lax.addPreset("parallaxSlow5", () => {
  return {
    "data-lax-translate-y_desktop": "800 300 ,500 0",
  };
});
